import { render, staticRenderFns } from "./chooseParkingArea.vue?vue&type=template&id=1f39f8e1"
import script from "./chooseParkingArea.vue?vue&type=script&lang=js"
export * from "./chooseParkingArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports